import { ModulesMap, ModulesConfigMap } from '@/config/data/modulesMaps'
import { _apiRequestWrap } from '../apiService'

function _getRegulationsStagesPlanWorksRecomendedMachines(options = {}) {
	return _apiRequestWrap(
		ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_RECOMENDED_MACHINES,
		ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_RECOMENDED_MACHINES]
			.GET_REGULATIONS_STAGES_PLAN_WORKS_RECOMENDED_MACHINES,
		options
	)
}


export default {
	[ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_RECOMENDED_MACHINES]
		.GET_REGULATIONS_STAGES_PLAN_WORKS_RECOMENDED_MACHINES]: _getRegulationsStagesPlanWorksRecomendedMachines,
}
